module.exports = "https://static.wagwalking.com/_next/static/images/become-a-walker-background-mobile-dfb1c785107fd97f006281422f1de0ce.jpg";